import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import PtfButton from "@/components/PtfButton";
import { Reveal } from "@/components/motion/Reveal";
import { StatusBadge } from "@/components/learning/ProgrammeCard";
import { FIELD_EXPERIENCES } from "@/lib/learning";

export default function FieldExperiences() {
  return (
    <>
      <Seo title="Field Experiences: Learn in the Field" path="/learning/field" description="Planet Trotter field experiences: village immersion, rural tourism, tree plantation, conservation, wildlife and wilderness experiences. Not conventional courses; learning that happens in the field." />
      <PageHero
        eyebrow="Field Learning · Learn in the field"
        titleLines={["These are not", "conventional courses."]}
        intro="Field experiences put you inside working Planet Trotter contexts: villages, rivers, forests and plantation sites. Every experience carries an honest status."
        image="/dawn/vor-village.jpg"
      />
      <section className="bg-ptf-bg py-16 md:py-24">
        <div className="mx-auto max-w-[1600px] px-5 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {FIELD_EXPERIENCES.map((f, i) => (
              <Reveal key={f.name} delay={(i % 2) * 0.05}>
                <div data-testid={`field-exp-${f.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="bg-white border border-ptf-primary/12 p-7 h-full flex flex-col">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-display uppercase text-2xl tracking-tight text-ptf-primary">{f.name}</h3>
                    <StatusBadge status={f.status} />
                  </div>
                  <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 text-sm text-ptf-text/75 leading-relaxed flex-1">
                    <p><span className="text-[0.6rem] uppercase tracking-[0.16em] text-ptf-text/45 block">Location</span>{f.location}</p>
                    <p><span className="text-[0.6rem] uppercase tracking-[0.16em] text-ptf-text/45 block">Duration · Group</span>{f.duration} · {f.group}</p>
                    <p className="sm:col-span-2"><span className="text-[0.6rem] uppercase tracking-[0.16em] text-ptf-text/45 block">Activities</span>{f.activities}</p>
                    <p><span className="text-[0.6rem] uppercase tracking-[0.16em] text-ptf-text/45 block">Learning outcomes</span>{f.outcomes}</p>
                    <p><span className="text-[0.6rem] uppercase tracking-[0.16em] text-ptf-text/45 block">Community connection</span>{f.community}</p>
                    <p className="sm:col-span-2"><span className="text-[0.6rem] uppercase tracking-[0.16em] text-ptf-text/45 block">Environmental connection</span>{f.environment}</p>
                  </div>
                  <p className="mt-4 text-[0.62rem] text-ptf-text/50 leading-relaxed border-t border-ptf-primary/10 pt-3">
                    Safety: field experiences follow the universal Planet Trotter safety framework; prerequisites and equipment are stated per edition.
                    {f.note && <span className="block mt-1 text-ptf-secondary">{f.note}</span>}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-12 flex flex-col sm:flex-row gap-3">
            <PtfButton to="/learning/training" data-testid="fieldexp-training-cta">Browse Training Programmes</PtfButton>
            <PtfButton to="/exploration" variant="outline">Documentary Field Experiences</PtfButton>
          </div>
        </div>
      </section>
    </>
  );
}
